module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicholas Blincoe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Nicholas Blincoe is an author, critic and screenwriter. His many novels include the highly-acclaimed Manchester Slingback, which won the CWA Silver Dagger award in 1998. Born in Rochdale, he attended the University of Warwick, where he completed a PhD in contemporary European philosophy.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2A7IXr/tc-custom/9781910859452.jpg?1726871176449",
      "alt": "This image is the cover for the book Jello Salad"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jello Salad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A mob wife opens a London restaurant, serving a full banquet of mayhem and violence in this “riotously good read” by the author of "), _c('i', [_vm._v("Acid Casuals")]), _vm._v(" ("), _c('i', [_vm._v("Observer")]), _vm._v(").")])]), _c('p', [_vm._v(" They’re opening a new restaurant in London’s posh SoHo district. Susan Ball, a mob wife turned restaurateur, is funding the joint with money she stole from her notorious husband, Frank ‘Ballistic’ Ball. The cook is a former celebrity chef whose insatiable perversions were too hot for TV. And as for the Maitre D, his drug-fueled spiritual journey in Goa has certainly made him more unique, but it hasn’t made him any more trustworthy. This might sound like a recipe for disaster—but that’s just the first course. ")]), _c('p', [_c('b', [_vm._v("‘This black comedy of modern bad manners aims at outrage and hits the bull’s eye every time . . . A must-read” —Val McDermid")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0